import React from 'react';
import { useSelector } from 'react-redux'
import { Card, CardBody, CardHeader, Label, Input, Button } from 'reactstrap';

import './YesNo.scss'

type Props = {
  label: string;
  value: boolean;
  disabled?: boolean;
  error?: string;
  yesTitle?: string;
  noTitle?: string;

  onChange: (checked: boolean) => void;
}
const YesNo = (props: Props) => {
  const activateId = 'activate_' + Math.random()
  const deactivateId = 'deactivate_' + Math.random()

  return (
    <div className="input-wrapper yes-no" style={{marginTop: 20}}>
      <div className="date-label">{props.label}</div>
      <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
        <div style={{paddingLeft: 22}}>
          <Input
            type="checkbox"
            checked={props.value}
            disabled={props.disabled}
            id={activateId}
            onChange={(evt) => props.onChange(evt.target.checked)}
            />
          <Label for={activateId}>{props.yesTitle || 'Oui'}</Label>
        </div>

        <div style={{paddingLeft: 42}}>
          <Input
            type="checkbox"
            checked={!props.value}
            disabled={props.disabled}
            id={deactivateId}
            onChange={(evt) => props.onChange(!evt.target.checked)}
            />
          <Label for={deactivateId}>{props.noTitle || 'Non'}</Label>
        </div>
      </div>

      { props.error !== undefined &&
        <div className="form-error">{props.error}</div>
      }
    </div>
  )
}

export default YesNo;
